import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import { tenantTokenGuard } from '@/features/auth/guards/tenantTokenGuard.js'
import { clubRegisteredGuard } from '@/features/router/guards/clubRegisteredGuard.js'
import { trackingForProfileRoutes } from '@/features/tracking/trackingForProfile/trackingForProfileRoutes.js'
import DummyRouter from '@/features/ui/components/DummyRouter.vue'

import { redirectLandingWhenClubContextMissing } from './clubLandingRedirect.js'
import { clubLandingHomeGuard } from './guards/clubLandingHomeGuard.js'

const commonGuard = [authGuard, sessionGuard, clubRegisteredGuard, tenantTokenGuard]

export const clubLandingRoutes = [
  {
    path: '',
    component: () => import('./ClubLandingHomeView.vue'),
    beforeEnter: clubLandingHomeGuard,
  },
  {
    path: 'landing',
    component: DummyRouter,
    beforeEnter: commonGuard,
    children: [
      {
        path: '',
        beforeEnter: redirectLandingWhenClubContextMissing,
        component: () => import('./clubLandingHome/ClubLandingHomeLoggedView.vue'),
        children: [
          {
            path: '',
            component: () => import('./clubLandingHome/ClubLandingHomeLoggedViewMemberships.vue'),
          },
          {
            path: 'profile',
            component: () => import('./clubLandingProfile/ClubLandingProfileView.vue'),
          },
        ],
      },
      {
        path: 'events',
        component: DummyRouter,
        children: [
          {
            path: '',
            component: () =>
              import('@/features/eventManagement/views/public/EventResponsePublicAuthLayout.vue'),
            children: [
              {
                path: 'response',
                component: () =>
                  import('@/features/eventManagement/views/public/onboard/EventResponsePublicOnboard.vue'),
              },
            ],
          },
        ],
      },
    ],
  },

  ...trackingForProfileRoutes(commonGuard),
]
